<template>
  <v-sheet color="transparent" width="100%" class="item">
    <LoadingWidget v-if="loading" class="py-16" />
    <transition name="fade">
      <template v-if="!loading">
        <v-container class="py-8 py-md-12 py-lg-16">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="6">
              <div class="d-flex justify-center">
                <TitleWidget
                  class="text-center"
                  v-if="xs"
                  :title="item.title"
                />
              </div>

              <v-sheet class="mt-3 mt-md-5 mt-lg-7 mb-6 mb-md-0 item-images">
                <zoom-on-hover
                  :img-normal="`${imgHighlight}?resize=1&w=500`"
                  :img-zoom="`${imgHighlight}?resize=1&w=800`"
                  :scale="1.2"
                  class="
                    d-flex
                    align-center
                    justify-center
                    item-image-highlight
                  "
                  v-if="imgHighlight"
                />

                <div v-if="images" class="mt-4 mt-md-0 justify-md-end">
                  <hooper-container
                    :settings="hooperSettings"
                    class="carousel-product-item"
                  >
                    <hooper-slide v-for="(img, key) in images" :key="key">
                      <v-btn
                        @mouseover="imgHighlight = img"
                        href="javascript:void(0);"
                        :class="
                          `pa-0 item-image-thumbnail` +
                          (imgHighlight === img ? ` active` : ``)
                        "
                        height="80px"
                        width="80px"
                        tile
                        depressed
                      >
                        <img
                          :src="`${img}?resize=1&w=65`"
                          :alt="item.title"
                          class="item-image"
                        />
                      </v-btn>
                    </hooper-slide>
                  </hooper-container>
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="6">
              <TitleWidget
                v-if="!xs"
                class="primary--text"
                :title="item.title"
              />

              <div v-if="whatsapp && whatsapp.length" class="pt-md-8">
                <div class="d-flex justify-center justify-lg-start">
                  <span
                    class="font-weight-medium text-h5 primary--text text-center"
                    >Solicite um orçamento:</span
                  >
                </div>

                <div class="d-flex flex-wrap justify-center justify-md-start">
                  <ButtonWidget
                    v-for="({ text, link }, i) in whatsapp"
                    :key="i"
                    :href="link"
                    target="_blank"
                    big
                    class="mr-2 mt-3"
                  >
                    <v-icon size="28" class="mr-3"> fa-whatsapp </v-icon>
                    {{ text }}
                  </ButtonWidget>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="item.text">
            <v-col cols="12">
              <div
                class="
                  mt-8
                  px-6 px-md-8
                  py-8 py-sm-10 py-md-12 py-lg-14
                  item-text
                "
              >
                <div
                  class="
                    text-h6 text-sm-h5 text-lg-h4
                    primary--text
                    font-weight-bold
                  "
                >
                  Descrição
                </div>
                <div
                  class="grey--text text-body-1 mt-3 mt-md-4 ck-content"
                  v-html="item.text"
                ></div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </transition>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import ButtonWidget from "../components/widgets/ButtonWidget.vue";
import { getWhatsappLinkFromPhone } from "../utils/getWhatsappLinkFromPhone";

const _config = {
  mod: "products",
  path: "/produtos",
};

export default {
  data: () => ({
    loading: true,
    item: {},
    images: [],
    imgHighlight: "",
    hooperSettings: {
      itemsToShow: 3,
      vertical: false,
      breakpoints: {
        360: {
          itemsToShow: 4,
          vertical: false,
        },
        450: {
          itemsToShow: 5,
          vertical: false,
        },
        600: {
          itemsToShow: 3,
          vertical: false,
        },
        700: {
          itemsToShow: 4,
          vertical: false,
        },
        960: {
          itemsToShow: 4,
          vertical: true,
        },
        1200: {
          itemsToShow: 5,
          vertical: true,
        },
      },
    },
  }),
  computed: {
    whatsapp() {
      return this.$rest("informations").item.whatsapp
        ? this.$rest("informations")
            .item.whatsapp.split(";")
            .map((item) => ({
              text: item,
              link:
                getWhatsappLinkFromPhone(item) +
                "?text=Olá, gostaria de mais informações sobre o produto: " +
                this.item.title,
            }))
        : this.$rest("informations").item.whatsapp_float;
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;

          this.imgHighlight = this.files + data.img.featured.path;

          this.images = data.img.list.map(({ path }) => {
            return path ? this.files + path : "";
          });
        })
        .then(() => (this.loading = false))
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    LoadingWidget,
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item-image-highlight {
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15) !important;
  padding: 20px;
  width: 100%;
}
.item-images {
  display: grid;
  grid-template-columns: auto 100px;
  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
  }
  .item-image {
    max-height: 80px;
    max-width: 80px;
    object-fit: contain;
    -o-object-fit: contain;
    object-position: center;
    -o-object-position: center;
    width: 100%;
  }
}
.item-text {
  border: 1px solid #dddddd;
}
</style>

<style lang="scss">
.item-image-highlight {
  .normal {
    aspect-ratio: 1 / 1;
    display: block;
    object-fit: contain;
    -o-object-fit: contain;
    width: 100%;
  }
}
.carousel-product-item {
  height: 100% !important;
  width: 100%;
}
</style>
